import React from 'react';

import { LayoutWrapper } from '../layout/layout-wrapper';

import styles from './styles.module.scss';

export const App = () => {
	return (
		<div className={styles.app__wrapper}>
			<LayoutWrapper />
		</div>
	);
};
